import { useState, useEffect } from 'react';
import { HostBackend } from '../../Routes/HostBackend.js';
import { GetHeaders } from '../../Components/Admin/Functions/FetchHeaders.js';
import { FilterArchives } from '../../Components/Public/Filters/FilterArchives.js';
import { FilterArchivesByType } from '../../Components/Public/Filters/FilterArchivesByType.js';
import { GetDescription } from '../../Components/Public/Functions/GetDescription.js';
import { ScrollTop } from '../../Components/Public/Functions/ScrollTop.js';
/* document */
import { Navigation } from '../../Components/Public/Document/Navigation.js';
import { Header } from '../../Components/Public/Document/Header.js';
import { Footer } from '../../Components/Public/Document/Footer.js';
import { BreadCrumb } from '../../Components/Public/Document/Breadcrumb.js';
import { BreadTags } from '../../Components/Public/Document/BreadTags.js';
import { BlockLegend } from '../../Components/Public/Blocks/BlockLegend.js';
import { BlockLogoArchives } from '../../Components/Public/Logos/BlockLogoArchives.js';
import { BlockTitleDate1Link0 } from '../../Components/Public/Blocks/BlockTitleDate1Link0.js';
import { BlockOutlink } from '../../Components/Public/Blocks/BlockOutlink.js';
import { BackTop } from '../../Components/Public/Document/BackTop.js';

export const ArchivesAttractions = (props) => {
    const parks = props.navParks;
    const backend = HostBackend();
    const guest = sessionStorage.getItem('guest');
    const [archives, setArchives] = useState([]);
    const [body, setBody] = useState([]);
    useEffect(() => {
        const fetchtheData = async () => {
            const dataArchives = await fetch(`${backend}/archives`, GetHeaders(guest));
            const archives = await dataArchives.json();
            setArchives(archives);
            const bodyArchives = await fetch(`${backend}/archives/body`, GetHeaders(guest));
            const body = await bodyArchives.json();
            setBody(body);
        };
        fetchtheData();
        ScrollTop();
    }, [backend, guest]);
    const archivesType = FilterArchives(archives);
    const items = GetDescription('archives', { body: body, archives: archives })
    return (
        <div className="archive">
            <Navigation navParks={parks} />
            <Header />
            <BreadCrumb label="archives" />
            <section className="infos">
                <div className="content">
                    <BreadTags label="archives" datas={archivesType} />
                    <BlockLegend parks={parks} />
                    {archivesType.map((el, i) => {
                        const archivesByType = FilterArchivesByType(archives, el.cid);
                        const total = archivesByType.length;
                        return (
                            <div className="origintype" key={`i-${i}`}>
                                <div className="title-list" id={el.cslug}>{`${el.cname} (${total})`}</div>
                                <div className="list">
                                    {archivesByType.map((e, i) => {
                                        return (
                                            <BlockLogoArchives item={e} key={i} />
                                        )
                                    })}
                                </div>
                            </div>
                        )
                    })}
                </div>
                <div className="description">
                    <BlockTitleDate1Link0 label="archives" items={items} />
                    <p>{items.description}</p>
                    <BlockOutlink items={items} />
                </div>
            </section>
            <BackTop />
            <Footer />
        </div>
    )
}